var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSync(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3413",
    "data-name": "Rectangle 3413",
    width: 24,
    height: 24,
    transform: "translate(1778 21)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_43",
    "data-name": "Rectangle 43",
    width: 14.8,
    height: 11.134,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_4678",
    "data-name": "Mask Group 4678",
    transform: "translate(-1778 -21)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_30",
    "data-name": "Group 30",
    transform: "translate(565.601 9.238)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_29",
    "data-name": "Group 29",
    transform: "translate(1217 19)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_28",
    "data-name": "Group 28",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_43",
    "data-name": "Path 43",
    d: "M87.12,113.544a.592.592,0,0,1-.421-.175l-1.7-1.7a.965.965,0,0,1,0-1.365l1.705-1.7a.6.6,0,0,1,.846,0l.011.011a.6.6,0,0,1,0,.841l-.7.7s-.205.2-.173.2l1.573,0,1.283,0c.576,0,1.054,0,1.5,0a3.819,3.819,0,0,0,3.807-3.138c.026-.131.041-.261.054-.383a.263.263,0,0,1,.263-.236h.76a.265.265,0,0,1,.264.255c-.015.088-.029.176-.043.265-.03.193-.062.392-.1.583a5.065,5.065,0,0,1-4.069,3.834,7.141,7.141,0,0,1-1.049.085c-.488,0-1.023.006-1.683.006h-2.5l.855.854a.6.6,0,0,1,0,.847l-.052.051a.593.593,0,0,1-.418.171",
    transform: "translate(-81.39 -102.409)",
    fill: "#0a64f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44",
    "data-name": "Path 44",
    d: "M.265,6.944A.265.265,0,0,1,0,6.661a4.323,4.323,0,0,1,.165-.949A5.058,5.058,0,0,1,3.855,2.082a4.875,4.875,0,0,1,1.337-.16H9.484l-.875-.875a.608.608,0,0,1,0-.859l.01-.01a.608.608,0,0,1,.859,0l1.689,1.689a.965.965,0,0,1,0,1.364L9.459,4.94a.6.6,0,0,1-.845,0L8.6,4.919a.6.6,0,0,1,0-.843L9.47,3.19H6.643c-.569,0-1.041,0-1.485,0A3.827,3.827,0,0,0,1.326,6.335c-.025.13-.04.26-.052.371a.264.264,0,0,1-.263.238Z",
    transform: "translate(0)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSync);
export default __webpack_public_path__ + "static/media/sync.b9a97c22e7bc25cf49301c949db2fda7.svg";
export { ForwardRef as ReactComponent };